<template>
    <div class="search-results">
        <div class="row">
            <div :class="`col-md-${width}`">
                <div v-if="results" class="results-wrapper">
                    <div class="result-group" v-if="results[0].results.length">
                        <div class="result-group-name">{{ results[0].name }}</div>
                        <ul class="results">
                            <li v-for="(result, index) in results[0].results" :key="result.id" :class="[((selectedResult !== null) && (selectedResult === index)) ? 'selected' : '']">
                                <a :href="result.link" v-html="highlight(result.name)"></a>
                            </li>
                        </ul>
                    </div>
                    <div class="result-group" v-if="results[1].results.length">
                        <div class="result-group-name">{{ results[1].name }}</div>
                        <ul class="results">
                            <li v-for="(result, index) in results[1].results" :key="result.id" :class="[((selectedResult !== null) && (selectedResult - results[0].results.length === index)) ? 'selected' : '']">
                                <a :href="result.link" v-html="highlight(result.name)"></a>
                            </li>
                        </ul>
                    </div>
                    <div class="result-group" v-if="results[2].results.length">
                        <div class="result-group-name">{{ results[2].name }}</div>
                        <ul class="results">
                            <li v-for="(result, index) in results[2].results" :key="result.id" :class="[((selectedResult !== null) && (selectedResult - results[0].results.length - results[1].results.length === index)) ? 'selected' : '']">
                                <a :href="result.link" v-html="highlight(result.name)"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

  props: {
      results: {
          type: Array,
          default: null
      },
      query: {
          default: null
      },
      width: {
          default: 12
      },
      selectedResult: {
          default: null
      }
  },

  methods: {

      highlight(value) {
        return value.replace(new RegExp('(' + this.query + ')', "gi"), '<span class="hit">$1</span>');
      }

  }

}
</script>

